import {
  IUserAnnotations,
  Types,
  IExternalSender,
} from "../../../../redux/types/types";
import { IUserForm } from "../../form/IUsersForm";
import {
  addUser,
  assignModulesUser,
  assignOfficesUser,
  deleteUser,
  editUser,
  getUserByDocument,
  getUserByEmail,
  getUserById,
  getUsersByEntity,
} from "../../firebase/UsersService";
import {
  setSuccessMsg,
  uiOpenAlertExists,
  uiOpenSuccessAlert,
} from "../../../../redux/actions/uiActions";
import { uploadFileAsync } from "../../../../helpers/UploadFile";
import {
  uiOpenErrorAlert,
  uiCloseModalAssignModules,
} from "../../../../redux/actions/uiActions";
import { Office } from "../../doc/OrganizationChart";
import {
  getCorrespondenceUserAddressee,
  getCorrespondenceUserAnswerd,
  getCorrespondenceUserExternalSender,
  getOfficeById,
} from "../../../../services/firebase/correspondence";
import { setUserFormToUSer } from "../../adapter/UserAdapter";
import {
  deleteFirebaseUser,
  registerWithEmailPassword,
} from "../../../auth/firebase/AuthService";
import { IValidateUser } from "../../form/IValidateUser";
import { IAuditDoc } from "../../../audit/doc/IAuditDoc";
import { deleteUserAudit } from "../../../audit/firebase/AuditServices";

export const startNewUser = (user: IUserForm) => {
  return async (dispatch: any, getState: any) => {
    const { idEntity, businessName } = getState().auth.user;
    const { email, document, firstName, firstLastName } = user;
    let { profileImage, secondName, secondLastName } = user;
    user.document = Number(document);

    const existsUserDocument = await getUserByDocument(user.document, idEntity);
    const existsUserEmail = await getUserByEmail(email, idEntity);

    if (existsUserDocument.length > 0 || existsUserEmail.length > 0) {
      dispatch(uiOpenAlertExists());
    } else {
      try {
        // Manejo de imagen de usuario
        if (profileImage) {
          const uriResponse = await uploadFileAsync(
            profileImage as File,
            `avatars/${document}`
          );
          user.profileImage = uriResponse;
        } else {
          user.profileImage = null;
        }

        user.idEntity = idEntity;
        user.businessName = businessName;

        const { localId } = await registerWithEmailPassword(
          email,
          document.toString()
        );

        var userdoc = setUserFormToUSer(user, localId);

        await addUser(userdoc);

        dispatch(addNewUser(userdoc));
        dispatch(uiOpenSuccessAlert());
      } catch (error: any) {
        throw new Error(error);
      }
    }
  };
};

const addNewUser = (user: IUserForm) => ({
  type: Types.userAddNew,
  payload: user,
});

// Cargar usuarios del admin
export const startLoadingUsers = (idEntity: string) => {
  return async (dispatch: any) => {
    const resp = await getUsersByEntity(idEntity);

    dispatch(setUsers(resp));
  };
};
const fetchOfficesDetails = async (officesIds: string[]) => {
  const officesArr: Office[] = [];
  for (const office of officesIds) {
    const resp = await getOfficeById(office);
    resp && officesArr.push(resp);
  }

  return officesArr;
};
export const startLoadingUsersAnnotations = (idEntity: string) => {
  return async (dispatch: Function) => {
    const resp = await getUsersByEntity(idEntity);
    //poner por defecto la propiedad selected en false y armar el label name
    const finalArrUsers: IUserAnnotations[] = [];
    for (const user of resp) {
      const detailsOffice = await fetchOfficesDetails(user.offices);
      let concatName = "";
      //@ts-ignore
      for (const [i, office] of detailsOffice.entries()) {
        const str =
          i < detailsOffice.length - 1 ? office.name + " " : office.name;
        concatName += str;
      }

      const finalName =
        user.firstName +
        " " +
        user.secondName +
        " " +
        user.firstLastName +
        " " +
        user.secondLastName +
        " - " +
        concatName.split(" ").join(" - ");

      const finalObj: IUserAnnotations = {
        ...user,
        selected: false,
        labelName: finalName,
      };
      finalArrUsers.push(finalObj);
    }
    dispatch(loadUsersAnnotations(finalArrUsers));
  };
};
export const loadUsersAnnotations = (users: IUserAnnotations[]) => ({
  type: Types.usersLoad,
  payload: users,
});

export const setUsers = (users: IUserForm[]) => ({
  type: Types.usersLoad,
  payload: users,
});

// Usuario activo
export const activeUser = (user: IUserForm) => ({
  type: Types.userActive,
  payload: user,
});

export const userCleanActive = () => ({ type: Types.userCleanActive });

// Editar usuario
export const startEditUser = (user: IUserForm, changeImage: boolean) => {
  return async (dispatch: Function) => {
    const { document, profileImage } = user;

    try {
      if (changeImage) {
        const uriResponse = await uploadFileAsync(
          profileImage as File,
          `avatars/${document}`
        );
        user.profileImage = uriResponse;
      }

      var userdoc = setUserFormToUSer(user, user.uid);
      userdoc.createdAt = user.createdAt;
      dispatch(activeUser(userdoc));

      await editUser(userdoc);
      dispatch(updateUser(user));
      dispatch(uiOpenSuccessAlert());
    } catch (error: any) {
      throw new Error(error);
    }
  };
};

export const updateUser = (user: IUserForm) => ({
  type: Types.userUpdated,
  payload: user,
});

export const startAssignModules = (user: IUserForm, modules: string[]) => {
  return async (dispatch: Function) => {
    try {
      await assignModulesUser(user, modules);
      dispatch(updateUser({ ...user, modules }));

      dispatch(uiCloseModalAssignModules());
      dispatch(setSuccessMsg("ModulesAssigned"));
      dispatch(uiOpenSuccessAlert());
    } catch (error) {
      dispatch(setSuccessMsg("ErrorAssigningModules"));
      dispatch(uiOpenErrorAlert());
    }
  };
};

// Cargar oficinas asignadas
export const startLoadAssignedOffices = (userOffices: string[]) => {
  return async (dispatch: Function, getState: Function) => {
    const { offices } = getState().organizationChart;

    const assignedOffices = offices.filter((office: Office) =>
      userOffices.includes(office.idOffice)
    );
    dispatch(setAssignedOffices(assignedOffices));
  };
};

export const setAssignedOffices = (offices: Office[]) => ({
  type: Types.userLoadAssignedOffices,
  payload: offices,
});

// Asignar oficinas
export const startAssignOffice = (idVersion: string, idOffice: any) => {
  return async (dispatch: Function, getState: Function) => {
    const { activeUser } = getState().users;
    const { offices } = getState().organizationChart;
    const user = { ...activeUser };
    let newOffices: string[] = [];

    const idProductionOffice =
      offices.length > 0
        ? offices.filter((office: Office) => office.idOffice === idOffice)[0]
            .idProductionOffice
        : "";

    const validateProductionOffice = activeUser.offices.some((office: string) =>
      office.includes(idProductionOffice)
    );

    if (activeUser.offices.length > 0 && !validateProductionOffice) {
      dispatch(setSuccessMsg("OnlyOneProducingOffice"));
      dispatch(uiOpenAlertExists());
    } else {
      if (activeUser.offices.includes(idOffice)) {
        dispatch(setSuccessMsg("OfficeAlreadyAssigned"));
        dispatch(uiOpenAlertExists());
      } else {
        newOffices = [...activeUser.offices, idOffice];
        activeUser.offices = newOffices;

        const officeFiltered =
          offices.length > 0
            ? offices.filter(
                (office: Office) =>
                  office.idOffice === idOffice && office.idVersion === idVersion
              )[0]
            : [];

        try {
          await assignOfficesUser(`${activeUser.id}`, newOffices);
          dispatch(updateUser({ ...user, offices: newOffices }));
          dispatch(updateUser({ ...activeUser }));
          dispatch(addNewAssignedOffice(officeFiltered));
          dispatch(setSuccessMsg("AssignedOffice"));
          dispatch(uiOpenSuccessAlert());
        } catch (error) {
          dispatch(setSuccessMsg("ErrorAssignOffice"));
          dispatch(uiOpenErrorAlert());
        }
      }
    }
  };
};

const addNewAssignedOffice = (office: Office) => ({
  type: Types.userAddAssignedOffice,
  payload: office,
});

// Eliminar oficina
export const startDeleteAssignedOffice = (office: Office) => {
  return async (dispatch: Function, getState: Function) => {
    const { activeUser } = getState().users;
    const user = { ...activeUser };
    const newOffices: string[] = activeUser.offices.filter(
      (el: string) => el !== office.idOffice
    );
    activeUser.offices = newOffices;

    try {
      await assignOfficesUser(`${activeUser.id}`, newOffices);
      dispatch(updateUser({ ...user, offices: newOffices }));
      dispatch(deleteAssignedOffice(office.idOffice));
      dispatch(setSuccessMsg("OfficeDeleted"));
      dispatch(uiOpenSuccessAlert());
    } catch (error) {
      dispatch(setSuccessMsg("ErrorDeletingAssignedOffice"));
      dispatch(uiOpenErrorAlert());
    }
  };
};

const deleteAssignedOffice = (idOffice: string) => ({
  type: Types.userDeleteAssignedOffice,
  payload: idOffice,
});

export const setActiveExternalSender = (sender: IExternalSender | null) => ({
  type: Types.setActiveExternalSender,
  payload: sender,
});

export const ValdiateDeleteUser = (values: IValidateUser) => {
  return async (dispatch: Function) => {
    try {
      dispatch(DeleteUserValidation(true));

      //valida si tiene correspondecias
      const correspondenceUserAddressee = await getCorrespondenceUserAddressee(
        values
      );

      if (correspondenceUserAddressee.length > 0) {
        dispatch(DeleteUserValidation(false));
        return;
      }

      //valida si tiene correspondecias
      const correspondenceUserExternalSender =
        await getCorrespondenceUserExternalSender(values);

      if (correspondenceUserExternalSender.length > 0) {
        dispatch(DeleteUserValidation(false));
        return;
      }

      //valida si tiene correspondecias
      const correspondenceUserAnswerd = await getCorrespondenceUserAnswerd(
        values
      );

      if (correspondenceUserAnswerd.length > 0) {
        dispatch(DeleteUserValidation(false));
        return;
      }
    } catch (error: any) {
      throw new Error(error);
    }
  };
};

export const setDeleteUser = (user: any) => {
  return async (dispatch: Function) => {
    try {
      dispatch(DeleteUser(user));
      const response = await deleteFirebaseUser(user.uid);

      if (!response || !response.status) {
        dispatch(setSuccessMsg("user.alertDeleteError"));
        dispatch(uiOpenErrorAlert());
        return null;
      }

      if (response.status === 200) {
        let userdata = await getUserById(user.id);

        if (!userdata) {
          dispatch(setSuccessMsg("user.alertDeleteError"));
          dispatch(uiOpenErrorAlert());
          return null;
        }

        const audit: IAuditDoc = {
          id: "",
          createdAt: new Date().toISOString(), // Add a timestamp
          action: "delete",
          user: user?.id,
          idEntity: userdata.idEntity,
        };
        deleteUserAudit(userdata, audit);

        await deleteUser(user);
      }

      dispatch(setSuccessMsg("user.alertDeleteSuccess"));
      dispatch(uiOpenSuccessAlert());
    } catch (error: any) {
      dispatch(setSuccessMsg("user.alertDeleteError"));
      dispatch(uiOpenErrorAlert());
      throw new Error(error);
    }
  };
};

export const DeleteUser = (user: IUserForm) => ({
  type: Types.userDelete,
  payload: user,
});

export const DeleteUserValidation = (data: boolean) => ({
  type: Types.userDeleteValdiation,
  payload: data,
});
